// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"MediaVideo_play_btn__DEgz8"};